import Responsive from 'semantic-ui-react/dist/es/addons/Responsive';

export default Responsive;
